
// vue
import { defineComponent, PropType, ref } from 'vue';

export default defineComponent({
  name: 'CustomButton',
  props: {
    type: {
      type: String as PropType<'rect' | 'round' | 'circle'>,
      required: true,
    },
    width: {
      type: Number,
      required: false,
    },
    height: {
      type: Number,
      required: false,
    },
    centering: {
      type: Boolean,
      required: false,
    },
  },
  setup(props) {
    const btnClass = ref(props.type);
    if (props.centering) {
      btnClass.value += ' center';
    }

    const width = ref(props?.width);
    const height = ref(props?.width);
    let style = '';
    if (width && height) {
      style = `width: ${width.value}px; height: ${height.value}px;`;
    }
    const btnStyle = ref(style);

    return {
      btnClass,
      btnStyle,
    };
  },
});
